import { useEffect } from "react"

export const useSyncDatasCaracteristicasEffect = (
  caracteristicasState,
  setCaracteristicasState
) => {
  useEffect(() => {
    setCaracteristicasState((prev) => {
      let changed = false
      const next = { ...prev }


      // Data 1ª Integralização ← Data Emissão
      if (!prev.dataIntegralizacaoManual) {
        const valorEmissao = prev.dataEmissao
        if (valorEmissao !== prev.dataIntegralizacao) {
          next.dataIntegralizacao = valorEmissao
          changed = true
        }
      }

      // atribui DataVencimento à DataCarência, se não tiver sido preenchida manualmente e Resgate Antecipado for diferente de "sim"
      if (!prev.dataCarenciaManual && prev.resgateAntecipado !== "sim") {
        const valorVencimento = prev.dataVencimento
        if (valorVencimento !== prev.dataCarencia) {
          next.dataCarencia = valorVencimento
          changed = true
        }
      }

      return changed ? next : prev
    })
  }, [
    caracteristicasState.dataEmissao,
    caracteristicasState.dataVencimento,
    setCaracteristicasState,
  ])
}
